import { makeStyles } from "@material-ui/core/styles";
import { Alert, AlertTitle } from "@material-ui/lab";
import React from "react";

const colors = (sev) => {
  switch (sev) {
    case "warning":
      return "#C9592D";
    case "error":
      return "#EB711A";
    case "info":
      return "#1F2B7B";
    default:
      return "#429C69";
  }
};

const customStyles = makeStyles({
  message: {
    width: "100%",
    margin: "auto 0",
  },
  outlinedInfo: {
    color: colors("info"),
    border: `1px solid ${colors("info")}`,
    "& .MuiAlert-icon": {
      color: colors("info"),
      padding: "8px 0px",
    },
  },
  outlinedWarning: {
    color: colors("warning"),
    border: `1px solid ${colors("warning")}`,
    "& .MuiAlert-icon": {
      color: colors("warning"),
      padding: "8px 0px",
    },
  },
  outlinedError: {
    color: colors("error"),
    border: `1px solid ${colors("error")}`,
    "& .MuiAlert-icon": {
      color: colors("error"),
      padding: "8px 0px",
    },
  },
});

export default ({ message, title, centerMessage, ...props }) => (
  <Alert
    classes={{ ...customStyles() }}
    {...props}
    style={{ textAlign: centerMessage ? "center" : null }}
  >
    {title && <AlertTitle>{title}</AlertTitle>}
    {message}
  </Alert>
);
